import { useCallback, useEffect, useRef } from "react";
import {
  useAddFormValidation
} from "../core/hooks/useAddFormValidation/useAddFormValidation.js";
function useValidateYupSchema(schema, options) {
  const rSchema = useRef(schema);
  const rOptions = useRef(options);
  useEffect(() => {
    rSchema.current = schema;
    rOptions.current = options;
  });
  const validator = useCallback((formState) => {
    const { disabled, message: message2, onUnmountBehavior, abortEarly: abortEarly2 = false, ...yupValidateOptions } = rOptions.current;
    try {
      rSchema.current.validateSync(formState, { abortEarly: abortEarly2, ...yupValidateOptions });
      return {};
    } catch (e) {
      const validationError = e;
      const errors = {};
      const errorSource = abortEarly2 ? [validationError] : validationError.inner;
      for (const error of errorSource) {
        const fieldName = error.path;
        errors[fieldName] = error.message;
      }
      return errors;
    }
  }, []);
  const {
    abortEarly,
    context,
    disableStackTrace,
    recursive,
    strict,
    stripUnknown,
    message,
    ...addFormValidationOptions
  } = options;
  const errorMessage = message ?? `Invalid value`;
  return useAddFormValidation(validator, { ...addFormValidationOptions, message: errorMessage });
}
export {
  useValidateYupSchema
};
//# sourceMappingURL=useValidateYupSchema.js.map
